import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
//import * as NGYTPackage from '../../package.json';

import { AppData } from '../../constants/app-data';
import { DataService } from '../../data.service';
import{ UrlConstant } from '../../constants/url-constant';


@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {
  @ViewChild('videoPlayer', { static: false }) videoplayer: ElementRef;
  playerConfig = "youtube_video";
  
  public runningVideo:any ={name:''};
  
  constructor(public appData: AppData,  private dataService: DataService) {
   }

	public videoList: Array<any>;

  ngOnInit(): void {
  	//this.appData.rightNavMenuDrawer.subscribe(rightMenuDrawer=> rightMenuDrawer.open());
  	//this.appData.isRightNavActive.next(true);
  	
  	this.getVideoConfigDetailByCompanyId();
  }
  ngOnDestroy():void {
  	//this.appData.rightNavMenuDrawer.subscribe(rightMenuDrawer=> rightMenuDrawer.close());
  	//this.appData.isRightNavActive.next(false);
  }
  
  
  
	getVideoConfigDetailByCompanyId(){
		console.log("=====this.appData.selectedComapnyId :" + this.appData.selectedComapnyId );
		if(this.appData.selectedComapnyId !== null && this.appData.selectedComapnyId !== undefined){
		  	this.prepareVideoConfigDetail(this.appData.selectedComapnyId);
	    } else {
	    	this.appData.user.subscribe(userData=> { 
	  		//this.userId = (userData !== null)? userData.id:""; 
	  		//this.userType = (userData !== null)? userData.individualType:"";
	  		if(userData){
		  		console.log("indivType:" + userData.individualType + "  loggedInuserid:"+userData.id + "  createdForCompany:"+userData.createdForCompany);
		  		
		  		if(this.appData.userId !== "Admin")
		  			this.prepareVideoConfigDetail(userData.createdForCompany);
	  		}
	   	 });
	    }
	}
	
	prepareVideoConfigDetail(companyId){
		let reqBody = {"createdForCompany": companyId};
		this.dataService.sendPostRequestWithBody(UrlConstant.apiGetVideoConfig, reqBody).subscribe((res: any)=>{
	      console.log(res);
	      this.videoList = res.data;
	    });
	}
  playVideo(videoDetail){
    this.runningVideo = videoDetail;
  
  	let arr = videoDetail.url.split("v=");
  	this.id = arr[1];
  	console.log("new videoId:" + this.id);
  	//this.player.cueVideoById(this.id, 1);
  	this.player.loadVideoById(this.id, 1,10);
	//this.player.cueVideoByUrl(videoDetail.url, 1);
	
	//this.player.loadVideoByUrl(videoDetail.url, 1);
	
  	this.player.mute();
  	this.player.playVideo();
  }
  
  
  
  
// Video playing from YouTube start
  //videoURL = "https://www.youtube.com/watch?v=NpJ_yg1QJVA";
  // https://youtu.be/l-3hbmyqbqk
  
  //https://www.npmjs.com/package/ngx-youtube-player-14
  private player;
  //player: YT.Player;
  public ytEvent;
  id = "";
  youtubeVideoPlayerVars = {
    cc_lang_pref: 'en',
  };
  height=400;
  width=800;

//#############################################################
  // Not implemented section
  //https://developers.google.com/youtube/iframe_api_reference
  public player1;
  fun1(){
 //  tag = document.createElement('script');
 //  		tag.src = "https://www.youtube.com/iframe_api";
 //  firstScriptTag = document.getElementsByTagName('script')[0];
 //     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  onYouTubeIframeAPIReady() {
   this.player1 = new YT.Player('player1', {
      height: '390',
      width: '640',
      videoId: 'M7lc1UVf-VE',
      playerVars: {
        'playsinline': 1
      },
      events: {
        'onReady': this.onPlayerReady,
        'onStateChange': this.onPlayerStateChange
      }
    });
  }
   onPlayerReady(event) {
        event.target.playVideo();
      }
		 done = false;
       onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING && !this.done) {
          //setTimeout(stopVideo, 6000);
          this.done = true;
        }
      }
       stopVideo() {
        this.player1.stopVideo();
      }      
//#############################################################

   youtubeVideoOnStateChange(event) {
    this.ytEvent = event.data;
    console.log(event.data);
    // -1 (unstarted)
	// 0 (ended)  (YT.PlayerState.ENDED)
	// 1 (playing) (YT.PlayerState.PLAYING)
	// 2 (paused) (YT.PlayerState.PAUSED)
	// 3 (buffering) (YT.PlayerState.BUFFERING)
	// 5 (video cued). (YT.PlayerState.CUED)
  }
  youtubeVideoOnQualityChange(event){
    //small / medium/ large/ hd720/ hd1080 / highres
  }
  youtubeVideoOnPlayRateChange(event){
  	
  }
  youtubeVideoSavePlayer(player) {
    this.player = player;
  }

  youtubeVideoPlayVideo() {
    this.player.playVideo();
  }

  youtubeVideoPauseVideo() {
    this.player.pauseVideo();
  }
  
  youtubeVideoOnError(event){
  	console.log('video error: ' + event.value);
  	//2 � The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.
	//5 � The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.
	//100 � The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.
	//101 � The owner of the requested video does not allow it to be played in embedded players.
	//150 � This error is the same as 101. It's just a 101 error in disguise!
  }
  
  youtubeVideoWidthChange(width){
  	console.log(width);
  	this.player.width = width;
  	console.log(this.player.width);
  }
// Video playing from YouTube end
  
  
  
// video playing from other than YouTube
  isPlay: boolean = false;
  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }
  playPause() {
    var myVideo: any = document.getElementById('my_video_1');
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  makeBig() {
    var myVideo: any = document.getElementById('my_video_1');
    myVideo.width = 560;
  }

  makeSmall() {
    var myVideo: any = document.getElementById('my_video_1');
    myVideo.width = 320;
  }

  makeNormal() {
    var myVideo: any = document.getElementById('my_video_1');
    myVideo.width = 420;
  }

  skip(value) {
    let video: any = document.getElementById('my_video_1');
    video.currentTime += value;
  }

  restart() {
    let video: any = document.getElementById('my_video_1');
    video.currentTime = 0;
  }
}
